export const createPatchObject = (original: any, updated: any) => {
    const patch: any = {};
    for (const key in updated) {
      if (updated[key] !== original[key]) {
        patch[key] = updated[key];
      }
    }

    if(original.id) patch.id = original.id;
    return patch;
  };
  